var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dealer-wait-status-legend"},_vm._l((_vm.entries),function(entry){return _c('span',{key:entry.label},[_c('span',{staticClass:"tag-level-desing dealer-wait-status-tag",class:entry.tone},[_vm._v(_vm._s(entry.label))]),_vm._v("\n    "+_vm._s(entry.meaning)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }